export const iconFontAwesomeMedicalHealthPlus = (
	<i className="fa-solid fa-plus"></i>
);
